/**
 * Custom error class for task cancellations initiated by the user.
 * This allows for type-safe detection of cancellation vs other errors.
 */
export class TaskCancellationError extends Error {
	public readonly taskId: string;
	public readonly timestamp: Date;

	constructor(taskId: string, message?: string) {
		super(message || `Task ${taskId} cancelled by user`);
		this.name = 'TaskCancellationError';
		this.taskId = taskId;
		this.timestamp = new Date();

		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, TaskCancellationError);
		}
	}

	/**
	 * Type guard to check if an error is a TaskCancellationError
	 */
	static isCancellationError(error: any): error is TaskCancellationError {
		return error instanceof TaskCancellationError;
	}
}